//import element
import User from "../views/user";
import Project from "../views/project";
import Profile from "../views/profile";

import Main from "../views/main";
import Taskmainpage from "../views/taskMainpage";
import Newsmainpage from "../views/newsMainpage";
import Aboutmainpage from "../views/aboutMainpage";
import Contactmainpage from "../views/contactMainpage";
import Leaderboard from "../views/leaderboard";
import Announcement from "../views/announcement";

import ConfigTaskmainpage from "../views/detailTaskmainpage";
import DetailNewspage from "../views/detailNewspage";
import CreateAnnouncement from "../views/createAnnouncement";
import CreateNews from "../views/createNews";
import SystemSetting from "../views/systemSetting";
import TaskCategory from "../views/taskCategory";
import CreateTaskCategory from "../views/createTaskCategory";
import ConfigSystem from "../views/configSystem";
import Submission from "../views/submission";
import Tutorialpage from "../views/tutorialpage";
import Teampage from "../views/teampage";

import Dashboard from "../views/dashboard";
import NewEventPage from "../views/createTaskpage";
import ConfirmForgot from "../views/confirmforgot";
import ForgotPass from "../views/forgotPass";
import ChatbotArena from "../views/chatbotArena";
import CreateAboutus from "../views/createAboutus";
import Corpuspage from "../views/corpus";
import CreateCorpuspage from "../views/createCorpus";
import TestSubmit from "../views/login/TestSubmit";

export const route = [
  {
    path: "/",
    name: "Home",
    // icon: <HomeOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: true,
    component: <Main />,
  },
  {
    path: "/news",
    name: "News",
    // icon: <FilterOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: true,
    component: <Newsmainpage />,
  },
  {
    path: "/task",
    name: "Task",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: true,
    component: <Taskmainpage />,
  },
  {
    path: "/aboutus",
    name: "About Us",
    // icon: <IdcardOutlined />,
    access: ["Administrator", "Member", "User"],
    showMenu: true,
    component: <Aboutmainpage />,
  },
  {
    path: "/contact",
    name: "Contact",
    // icon: <PhoneOutlined />,
    access: ["Administrator", "Member", "User"],
    showMenu: true,
    component: <Contactmainpage />,
  },
  // {
  //   path: "/chatbotarena",
  //   name: "Chatbot Arena",
  //   // icon: <PhoneOutlined />,
  //   access: ["Super Admin", "Administrator", "Member", "User"],
  //   showMenu: true,
  //   component: <ChatbotArena />,
  // },
  {
    path: "/team/:task_id",
    name: "Team",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator", "Member"],
    showMenu: false,
    component: <Teampage />,
  },
  {
    path: "/score/leaderboard/:task_id",
    // name: "Leaderboad",
    // icon: <UnorderedListOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <Leaderboard />,
  },
  {
    path: "/news/detail/:id",
    // name: "Leaderboad",
    // icon: <UnorderedListOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <DetailNewspage />,
  },
  {
    path: "/news/:action/",
    name: "Event",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator"],
    showMenu: false,
    component: <CreateNews />,
  },
  {
    path: "/news/:action/:id",
    name: "Event",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator"],
    showMenu: false,
    component: <CreateNews />,
  },

  {
    path: "/Dashboard",
    name: "Dashboard",
    // icon: <DashboardOutlined />,
    access: ["Super Admin", "Administrator"],
    showMenu: true,
    component: <Dashboard />,
  },
  {
    path: "/user",
    name: "User",
    // icon: <UserOutlined />,
    access: ["Super Admin"],
    showMenu: true,
    component: <User />,
  },
  {
    path: "/user/forgot/reset",
    name: "User",
    // icon: <UserOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <ForgotPass />,
  },
  {
    path: "/user/confirmpassword/:token",
    name: "User",
    // icon: <UserOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <ConfirmForgot />,
  },
  {
    path: "/announcement",
    name: "Announcement",
    // icon: <BankOutlined />,
    access: ["Super Admin"],
    showMenu: true,
    component: <Announcement />,
  },
  {
    path: "/profile",
    name: "Profile",
    // icon: <UserOutlined />,
    access: ["Super Admin", "Administrator", "Member"],
    showMenu: false,
    component: <Profile />,
  },
  // {
  //   path: "/project",
  //   name: "Project",
  //   // icon: <UnorderedListOutlined />,
  //   access: ["Member"],
  //   showMenu: true,
  //   component: <Project />,
  // },
  {
    path: "/task/detail/:id",
    name: "config_task_page",
    // icon: <HomeOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <ConfigTaskmainpage />,
  },
  {
    path: "/announcement/:action/",
    name: "config_task_page",
    // icon: <BankOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <CreateAnnouncement />,
  },
  {
    path: "/announcement/:action/:type/:name_announcement",
    name: "config_task_page",
    // icon: <BankOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <CreateAnnouncement />,
  },
  {
    path: "/announcement/:action/:task_id",
    name: "Event",
    // icon: <BankOutlined />,
    access: ["Super Admin", "Administrator"],
    showMenu: false,
    component: <CreateAnnouncement />,
  },
  {
    path: "/category",
    name: "Task Category",
    // icon: <TagOutlined />,
    access: ["Super Admin"],
    showMenu: true,
    component: <TaskCategory />,
  },
  {
    path: "/task/category/:action/:category_id",
    name: "Task Category",
    // icon: <TagOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <CreateTaskCategory />,
  },
  {
    path: "/task/category/:action",
    name: "Task Category",
    // icon: <TagOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <CreateTaskCategory />,
  },
  {
    path: "/setting",
    name: "System Setting",
    // icon: <SettingOutlined />,
    access: ["Super Admin"],
    showMenu: true,
    component: <SystemSetting />,
  },
  {
    path: "/setting/:action/:id/",
    name: "System Setting",
    // icon: <SettingOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <ConfigSystem />,
  },
  {
    path: "/setting/:action/:id/:name",
    name: "System Setting",
    // icon: <SettingOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <ConfigSystem />,
  },
  {
    path: "/task/:action",
    name: "Event",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator"],
    showMenu: false,
    component: <NewEventPage />,
  },
  {
    path: "/task/:action/:task_id",
    name: "Event",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator"],
    showMenu: false,
    component: <NewEventPage />,
  },

  {
    path: "/task/tutorial/:task_id",
    name: "Tutorial",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <Tutorialpage />,
  },
  {
    path: "/task/submission/:task_id",
    name: "Model",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator", "Member", "User"],
    showMenu: false,
    component: <Submission />,
  },
  {
    path: "/create/aboutus",
    name: "Config About Us",
    // icon: <SettingOutlined />,
    access: ["Super Admin"],
    showMenu: true,
    component: <CreateAboutus />,
  },
  {
    path: "/corpus",
    name: "Corpus",
    // icon: <SettingOutlined />,
    access: ["Super Admin", "Administrator", "Member"],
    showMenu: true,
    component: <Corpuspage />,
  },
  {
    path: "/corpus/:action/",
    name: "Event",
    // icon: <FlagOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <CreateCorpuspage />,
  },
  {
    path: "/corpus/:action/:id",
    name: "Event",
    // icon: <FlagOutlined />,
    access: ["Super Admin"],
    showMenu: false,
    component: <CreateCorpuspage />,
  },
  // test
  {
    path: "/testsubmit",
    name: "testsubmit",
    // icon: <FlagOutlined />,
    access: ["Super Admin", "Administrator", "Member"],
    showMenu: false,
    component: <TestSubmit />,
  },
];
